import { Pipe, PipeTransform } from "@angular/core";

@Pipe({ name: "raskNewlines" })
export class RaskNewlinesPipe implements PipeTransform {

    transform(value: string): string {
        return value.replace(/(?:\r\n|\r|\n)/g, "<br/>");
    }
}
